import api from '../utils/api';

export const trackingService = {
    // Send interaction data
    sendInteraction: async (interactionData) => {
        try {
            const response = await api.post('/track', interactionData);
            return response.data;
        } catch (error) {
            // Fail silently for analytics to not disrupt user experience
            console.warn('📊 Analytics tracking failed:', error.response?.data || error.message);
            throw error.response?.data || error.message;
        }
    },

    // Get interactions with filters (for admin/analytics dashboard)
    getInteractions: async (filters = {}) => {
        try {
            const response = await api.get('/track', { params: filters });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Batch send multiple interactions (for offline support)
    sendBatchInteractions: async (interactions) => {
        try {
            const response = await api.post('/track/batch', { interactions });
            return response.data;
        } catch (error) {
            console.warn('📊 Batch analytics tracking failed:', error.response?.data || error.message);
            throw error.response?.data || error.message;
        }
    },

    // Health check for analytics endpoint
    checkHealth: async () => {
        try {
            const response = await api.get('/health');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};
